import React, { useState, useContext, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Context } from "../../../Context";
import axios from "axios";
import {
  useQueryClient,
  useQuery,
  useIsFetching,
  useInfiniteQuery,
} from "@tanstack/react-query";
import uniqid from "uniqid";
import LibraryBook from "../../LibraryBook/LibraryBook";
import Results from "../../Results/Results";
import { AnimatePresence, motion } from "framer-motion";
import { Grid } from "react-loader-spinner";
import down from "../../../assets/down-arrow.svg";
import "./Library.css";
import {
  getLibrivoxLink,
  getGoogleData,
  getClassics,
  getLocalData,
} from "../../../helpers/getData";
import { jsonData, goToPage } from "../../../helpers/jsonData";
import { div } from "framer-motion/client";
import { result } from "lodash";

//TODO

const Library = () => {
  const queryClient = useQueryClient();
  const location = useLocation();
  const [pageNumber, setPageNumber] = useState(1);
  const [hasScrolled, setHasScrolled] = useState(false);
  const [results, setResults] = useState();
  const [render, setRender] = useState(false);

  const resultsRef = useRef(null);
  useEffect(() => {
    console.log("handleLoad");
    handleLoad();
  }, []);

  const goToTop = () => {
    if (resultsRef.current) {
      resultsRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  let allData = [];

  const handleScroll = () => {
    if (
      Math.ceil(window.innerHeight + window.pageYOffset) >=
      document.body.offsetHeight
    ) {
      setHasScrolled(true);
    } else {
      setHasScrolled(false);
    }
  };

  const handleLoad = async () => {
    const classics = await goToPage();
    console.log(classics);
    let googleResults = await getGoogleData(classics, pageNumber);
    setResults(googleResults);
    setPageNumber((prev) => prev + 1);
    goToTop();
  };

  return (
    <>
      <Results onScroll={handleScroll}>
        <div ref={resultsRef} className="ref"></div>
        <AnimatePresence>
          <motion.ul
            key="results"
            initial="hidden"
            animate="visible"
            variants={{
              visible: { transition: { staggerChildren: 0.5 } },
            }}
          >
            {results && (
              <>
                <div
                  onScroll={handleScroll}
                  className="results-ul library-layout"
                >
                  {results.map((book) => {
                    return (
                      <LibraryBook
                        location={location}
                        key={uniqid()}
                        className="library-book"
                        book={book}
                      ></LibraryBook>
                    );
                  })}

                  <a
                    href="#"
                    onClick={(e) => {
                      handleLoad(e, pageNumber);
                    }}
                  >
                    <img
                      // icons eight
                      src={down}
                      alt="load more results"
                      className="load-button"
                    />
                    <p className="load-caption">load more</p>
                  </a>
                </div>
              </>
            )}
          </motion.ul>
        </AnimatePresence>
      </Results>
    </>
  );
};

export default Library;
